import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { SortButtons } from "components/common/SortButtons";
import AddDepartment from "../departments/AddDepartment";
import { usePermissions } from "layouts/Admin";
import { changeStatus } from "slices/departmentSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchDepartmentsList } from "slices/departmentSlice";
import { departmentsSelector } from "slices/departmentSlice";
import { removeMultipleDepartments } from "slices/departmentSlice";
import { convertTimeToUTC } from "helpers/dateTimeFormats";
import { dateTimeFormat } from "helpers/dateTimeFormats";
const apiService = new Api();

function Department() {
  const dispatch = useDispatch()
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions();
  const { departments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(departmentsSelector);
  console.log("departments", departments)
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'department_name',
    sortDirection: 'desc',
    location_id: id,
  });

  React.useEffect(() => {
    dispatch(fetchDepartmentsList(1, { location_id: id }))
  }, [])

  const handleAddDepartmentPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const submitCallback = (status, message) => {
    if (status) {

      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchDepartmentsList(1, { location_id: id }))
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleRemoveItems = React.useCallback(() => {
    dispatch(removeMultipleDepartments({ ids: selectedItems }, submitCallback))
  }, [selectedItems])

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(departments.map((department) => department.id.toString()))
  }



  const renderTableHeader = React.useCallback(() => {

    const handleSort = (sortBy) => {
      if (sortConfig.sortDirection === 'desc') {
        setSortConfig({ sortBy, sortDirection: 'asc' })
        dispatch(fetchDepartmentsList(currentPage, { location_id: id, sortBy: sortBy, sortDirection: 'asc', search: searchTerm }))
      }
      else {
        setSortConfig({ sortBy, sortDirection: 'desc' })
        dispatch(fetchDepartmentsList(currentPage, { location_id: id, sortBy: sortBy, sortDirection: 'desc', search: searchTerm }))
      }
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Departments') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>

        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Department Name</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("name")}
              />
            </span>
          </div>
        </th>

        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Departmet Email</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("email")}
              />
            </span>
          </div>
        </th>

        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Updated at</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("updated_at")}
              />
            </span>
          </div>
        </th>
        
        {checkPermission('Status Departments') &&
          <th >Status</th>
        }
        {checkPermission('Edit Departments') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, departments])


  const renderTableContent = React.useCallback(() => {
    return (
      departments?.map((department, index) => {
        return <DepartmentItem department={department} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddDepartmentPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      })
    )
  }, [departments, selectedItems]);

  const handleClose = React.useCallback(() => {
    refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };


  const onBackButtonClick = () => {
    navigate(-1);
  }
  return (
    <>
      {/* <div className="content Tabs_content">
        <div className="nav_tab_area">
          <Link className="tabLink main_button" to={`/clients/accounts/facilities/${id}`}>Facilities</Link>
          <Link className="tabLink main_button active" to={`/clients/accounts/departments/${id}`}>Departments</Link>
        </div>
      </div> */}
      <ListLayout
        haveBackBtn={true}
        onBackButtonClick={onBackButtonClick}
        buttonTitle="Add Department"
        containerStyle={{ marginTop: '0' }}
        height={'tab_height'}
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        addButtonDisabled={!checkPermission('Create Departments')}
        totalPages={totalPages}
        fetchList={fetchDepartmentsList}
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        renderAddForm={(callback) => <AddDepartment item={addForm.item} userId={id} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Departments')} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddDepartmentPopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortConfig={sortConfig}
        loader={loader}
        searchPlaceholder="Search department ..."
        noOfItems={total}
      >
        {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      </ListLayout>
    </>
  )

}

const DepartmentItem = ({
  department, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(department?.user?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  React.useEffect(() => {
    setStatus(department?.user?.status || 0)

  }, [department])
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Departments') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={department.id} checked={selectedItems.includes(department.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {department?.user?.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {department?.user?.email}
      </td>
      <td style={getBackgroundStyle(status)}>
        {dateTimeFormat(department?.updated_at)}
      </td>
      {checkPermission('Status Departments') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(department?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Departments') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...department, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}

export default Department;